import { QueryKey } from '@/enums';
import { newQueryClient } from '@/queries/reactQueryConfig';
import {
  CognitoIdentityProviderClient,
  ConfirmForgotPasswordCommand,
  ForgotPasswordCommand,
  ResendConfirmationCodeCommand,
} from '@aws-sdk/client-cognito-identity-provider';
import { get } from 'lodash';
import { TenantEntity } from 'src/interfaces';

const client = new CognitoIdentityProviderClient({
  region: 'ap-southeast-1',
});
//not in use
// const getInfoUserPool = (): { clientId: string; region: string } => {
//   const userPoolInfo: AuthUserPoolInfo = JSON.parse(
//     localStorage.getItem('userPoolInfo') || '{}',
//   );

//   const { clientId } = userPoolInfo;
//   const region =
//     userPoolInfo.region || (process.env.REACT_APP_AWS_COGNITO_REGION as string);

//   return { clientId, region };
// };

export interface ConfirmResetPasswordParams {
  ClientId: string /* required */;
  ConfirmationCode: string /* required */;
  Password: string /* required */;
  Username: string;
}
export class CognitoService {
  static resendCode(username: string): Promise<any> {
    const tenantData = newQueryClient.getQueryData([QueryKey.SUB_DOMAIN]);

    const tenant = get(tenantData, 'data', {}) as TenantEntity;

    const { appClientId: clientId } = tenant;

    const params = {
      ClientId: clientId,
      Username: username.toLowerCase(),
      region: process.env.REACT_APP_AWS_COGNITO_REGION as string,
    };
    const command = new ResendConfirmationCodeCommand(params);
    return client.send(command);
  }

  static forgotPassword = (params: {
    password: string;
    verifyPassword: string;
    confirmationCode: string;
    userName: string;
  }): Promise<any> => {
    const tenantData = newQueryClient.getQueryData([QueryKey.SUB_DOMAIN]);

    const tenant = get(tenantData, 'data', {}) as TenantEntity;

    const { appClientId: clientId } = tenant;

    const parameters = {
      ClientId: clientId /* required */,
      ConfirmationCode: params.confirmationCode /* required */,
      Password: params.password /* required */,
      Username: params.userName.toLowerCase() /* required */,
      region: process.env.REACT_APP_AWS_COGNITO_REGION as string,
    };
    const command = new ConfirmForgotPasswordCommand(parameters);
    return client.send(command);
  };

  static confirmForgotPassword = (params: { email: string }): Promise<any> => {
    const tenantData = newQueryClient.getQueryData([QueryKey.SUB_DOMAIN]);

    const tenant = get(tenantData, 'data', {}) as TenantEntity;

    const { appClientId: clientId } = tenant;

    const parameters = {
      ClientId: clientId /* required */,
      Username: params.email.toLowerCase() /* required */,
      region: process.env.REACT_APP_AWS_COGNITO_REGION as string,
    };
    const command = new ForgotPasswordCommand(parameters);
    return client.send(command);
  };
}
